//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import isBefore from 'date-fns/is_before'
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now'
import { smartImagePath } from '@/tools/ObjectHelper'
import { KEY_BOOKED_RESERVATION, local } from '@/tools/storage'

export default {
  props: {
    activity: Object
  },
  data () {
    return {
      smartImagePath
    }
  },
  methods: {
    toBook () {
      if (!this.userInfo || !this.userInfo.id) {
        this.$vux.toast.text('請先登入', 'bottom')
        setTimeout(() => {
          this.$router.push(`/login?redirect=/activitynotice`)
        }, 1000)
        return
      }

      if (!this.userInfo.email) {
        this.$vux.toast.show({
          text: '預約活動將會發送活動詳情到您的信箱，您尚未填寫信箱，請先完善資料',
          position: 'bottom',
          time: 3000,
          type: 'text',
          width: '11em'
        })
        setTimeout(() => {
          this.$router.push(`/user/${this.userInfo.id}/editBaseInfo?redirect=/activitynotice`)
        }, 1500)
        return
      }

      this.$vux.loading.show({text: '正在為您預約活動...'})

      this.$store.dispatch('receiveCurrentActivity', {
        id: this.activity.id,
        cb: (data) => {
          this.$vux.loading.hide()
          if (!data || data.error) {
            this.$vux.toast.text(data ? data.error : '預約失敗，請重試', 'bottom')
            return
          }
          this.close()
          this.$vux.toast.text('預約成功', 'bottom')
        }
      })
    },
    toDetail () {
      let url = this.activity.url
      this.close()
      window.open(url, '_blank')
    },
    toNoMore () {
      const array = local.get(KEY_BOOKED_RESERVATION, true)
      if (!array) {
        local.save(KEY_BOOKED_RESERVATION, [this.activity.id])
      } else {
        array.push(this.activity.id)
        local.save(KEY_BOOKED_RESERVATION, array)
      }

      this.close()
    },
    close () {
      this.$emit('close')
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
    remainDays () {
      return 0
    },
    startDate () {
      if (!this.activity.email_send_at) {
        return ''
      }
      const date = this.activity.email_send_at.split(' ')[0].split('-')
      return `${date[0]}年${parseInt(date[1])}月${parseInt(date[2])}日`
    },
    isActive () {
      if (!this.activity.email_send_at) {
        return false
      }
      return isBefore(new Date(), new Date(this.activity.email_send_at.replace(/-/g, '/')))
    },
    distanceDate () {
      if (!this.activity.email_send_at) {
        return ''
      }
      return distanceInWordsToNow(new Date(this.activity.email_send_at.replace(/-/g, '/')))
        .replace('about', '')
        .replace(/days|day/g, '天')
        .replace(/hours|hour/g, '小時')
        .replace(/minutes|minute/g, '分鐘')
    }
  }
}
